<template>
  <div class="container-fluid">
    <reseller-form
      :loading="loading"
      :resellerData="reseller"
      :formErrors="formErrors"
      @resellerSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultReseller from "../defaultReseller";
import ResellerForm from "../partials/ResellerForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    ResellerForm,
  },

  mixins: [alertLeave],

  data() {
    return {
      reseller: cloneDeep(defaultReseller),
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    async handleSubmit(reseller) {
      this.loading = true;

      const resellerData = cloneDeep(reseller);
      delete resellerData.id;

      try {
        await this.$store.dispatch("resellers/add", resellerData);
        this.$notify({
          type: "success",
          message: this.$t("RESELLERS.RESELLER_ADDED"),
        });
        const reseller = await this.$store.getters["resellers/reseller"];
        this.$emit("onViewReseller", reseller, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
